import React, { useState } from "react";
import "../../Styles/homeComponents.css"
import configuration from "../../Assets/configuration.png";
// import { Player } from "video-react";
import menuClose from "../../Assets/menuClose.png";
import { Link} from "react-router-dom";
export default function Bynft() {
  const [isMenuShow, setIsMenuShow] = useState(false);
  const showmenu = () => {
    setIsMenuShow(!isMenuShow);
  };

  const menuStyles = {
    position: "fixed ",
    backgroundColor: "#515151",
    top: "9px",
    left: isMenuShow ? "0" : "-500%",
    padding: "10px",
    transition: "all 1s",
    WebkitTransition: "all 1s",
    borderTopRightRadius: "32px",
    borderBottomRightRadius: "32px",
    zIndex: 9999, 
  };
  const scrollToComponent = (sectionId) => {
    const element = document.getElementById(sectionId);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };  



  return (
    <div className="bynft">
      <div className="Container">
        <div className="top">
          <div className="topleft" onClick={showmenu}>
            <img src={configuration} alt="" />
          </div>

          <div style={menuStyles} className="menu">
            <div className="menucontainer">
            <div className="menuabout" onClick={() => scrollToComponent("about")}>
            ABOUT
          </div>
          <div className="menuabout" onClick={() => scrollToComponent("our_projects")}>
            OUR PROJECT
          </div>
          <div className="menuabout" onClick={() => scrollToComponent("our-services")}>
            OUR SERVICE
          </div>
          <div className="menuabout" onClick={() => scrollToComponent("contact")}>
            CONTACT US
          </div>
            </div>
            <div className="menuImg">
              <img src={menuClose} alt="menuClose" onClick={showmenu} />
            </div>
          </div>
          <Link to="/service" className="link">
            <div className="topRight">DEVELOPING SERVICES</div>
          </Link>
        </div>
        <div className="middleDiv">
          <div className="middleTop">
            <div className="compnyName">
              <span className="middlespan" >S</span>upix
            </div>
            <div className="compnytype">SOFTWARE COMPANY</div>
          </div>
          <div className="purchase">
            <Link to='/community' className="link">
            <div>JOIN OUR COMMUNITY</div>
            </Link>
          </div>
          <div className="middleBottom">
            <div>
              Supix Software company focusing on artificial intelligence,
              Blockchain technology, cryptocurrency, NFT, metaverse, search
              engine technology
            </div>
            <div>
              cloud computing, computer software, quantum computing, e-commerce,
              and consumer electronics.
            </div>
          </div>
        </div>
      </div>
      <div className="home_footer">PURCHASE NFT TO JOIN OUR COMMUNITY</div>
    </div>
  );
}
